angular.module('angus.services').service('usersService', [
    '$http', '$rootScope', 'constantsService',
    function ($http,  $rootScope, constantsService) {
        function getSubscribersUsers(subscriberKey) {
            return $http.get(`api/subscriber/${subscriberKey}/user/by-subscriber`, {apiV2: true})
                .then(function(response){
                    return response.data;
                })
        }

        return {
            getSubscribersUsers:getSubscribersUsers
        }
    }
]);